module.exports = __webpack_public_path__ + "components/country-flag/static/vu-786d056f174f138a2739511e8fa469e5.svg";